import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { HandySvg } from "handy-svg";
import ReactInputMask from "react-input-mask";
import Flatpickr from "react-flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import iconCross from "../../assets/icons/svg-sprite/close-cross--alt.svg";
import { selects } from "../../lib/select/initSelectize";
import { feedback } from "../../lib/api/api";

const options = {
  locale: {
    ...Russian,
    months: {
      ...Russian.months,
      longhand: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
    },
  },
  dateFormat: "d-m-Y",
  monthSelectorType: "static",
  altFormat: "d.m.Y",
  altInput: true,
  maxDate: "today",
};

const PopupForm = ({ setMessage }) => {
  const [errors, setErrors] = useState({});
  const [agreement, setAgreement] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    selects.popupForm();
    submitForm();
  }, []);

  function submitForm() {
    const formElement = document.getElementById("quality_modal_form");
    formElement.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(formElement);
      const banner = document.getElementById("messageBanner");
      feedback
        .feedback(
          formData.get("property_quality"),
          formData.get("property_callback_time"),
          formData.get("property_was_useful"),
          formData.get("property_operator_benevolence"),
          formData.get("property_appeal_day").replace(/-/g, "."),
          formData.get("property_appeal_time"),
          formData.get("property_appeal_phone"),
          formData.get("property_operators_name"),
          formData.get("property_communicated_with"),
          formData.get("property_detail_text"),
          formData.get("property_personal_data_agreement") ? 1 : 0
        )
        .then((res) => {
          console.log(res);
          if (res.error) {
            setErrors(res.reason);
            banner.style.display = "none";
            if (formData.get("property_personal_data_agreement")) {
              setAgreement(true);
            } else {
              setAgreement(false);
            }
          } else {
            setErrors({});
            if (formData.get("property_personal_data_agreement")) {
              banner.style.removeProperty("display");
              setMessage(
                "Спасибо за вашу оценку. Сообщение успешно отправлено!"
              );
              setAgreement(true);
              e.target.reset();
              selects.formClear();
              setDate("");
              const formPopup = document.getElementsByClassName(
                "js-popup-form-overlay"
              )[0];
              const closeBtn =
                formPopup.getElementsByClassName("js-close-popup-btn")[0];
              closeBtn.dispatchEvent(new Event("click"));
            } else {
              banner.style.display = "none";
              setAgreement(false);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  return (
    <>
      <div className="page__popup-form-overlay js-popup-form-overlay">
        <section className="form">
          <h6 className="form__title title title--h3">
            Оценка качества обслуживания абонентов
          </h6>
          <div className="form__description">
            <p>
              Поделитесь вашим мнением о качестве наших услуг. Мы будем вам
              очень признательны. Это простое действие поможет нам учесть все
              пожелания наших абонентов и стать ещё лучше!
            </p>
          </div>
          <form id="quality_modal_form" className="form__itself" method="POST">
            <div className="form__form-body">
              <div className="form__line">
                <div
                  className={
                    "select js-select select--md form__item form__item--md" +
                    (errors.property_quality ? " has-error" : "")
                  }
                >
                  <select
                    className="select__item"
                    id="property_quality"
                    name="property_quality"
                    placeholder="Качество обслуживания*"
                  >
                    <option></option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                  <div class="form__error active">
                    {errors.property_quality
                      ? errors.property_quality
                          .map((item) => `${item}`)
                          .join("")
                      : ""}
                  </div>
                </div>
                <div
                  className={
                    "select js-select select--md form__item form__item--md" +
                    (errors.property_callback_time ? " has-error" : "")
                  }
                >
                  <select
                    className="select__item"
                    id="property_callback_time"
                    name="property_callback_time"
                    placeholder="Быстрота ответа*"
                  >
                    <option></option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                  <div class="form__error active">
                    {errors.property_callback_time
                      ? errors.property_callback_time
                          .map((item) => `${item}`)
                          .join("")
                      : ""}
                  </div>
                </div>
              </div>
              <div className="form__line">
                <div
                  className={
                    "select js-select select--md form__item form__item--md" +
                    (errors.property_was_useful ? " has-error" : "")
                  }
                >
                  <select
                    className="select__item"
                    id="property_was_useful"
                    name="property_was_useful"
                    placeholder="Помогло ли обращение*"
                  >
                    <option></option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                  <div class="form__error active">
                    {errors.property_was_useful
                      ? errors.property_was_useful
                          .map((item) => `${item}`)
                          .join("")
                      : ""}
                  </div>
                </div>
                <div
                  className={
                    "select js-select select--md form__item form__item--md" +
                    (errors.property_operator_benevolence ? " has-error" : "")
                  }
                >
                  <select
                    className="select__item"
                    id="property_operator_benevolence"
                    name="property_operator_benevolence"
                    placeholder="Доброжелательность оператора*"
                  >
                    <option></option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                  </select>
                  <div class="form__error active">
                    {errors.property_operator_benevolence
                      ? errors.property_operator_benevolence
                          .map((item) => `${item}`)
                          .join("")
                      : ""}
                  </div>
                </div>
              </div>
              <div className="form__line">
                <div
                  className={
                    "form__item form__item--md" +
                    (errors.property_appeal_day ? " has-error" : "")
                  }
                >
                  <Flatpickr
                    value={date}
                    id="property_appeal_day"
                    name="property_appeal_day"
                    placeholder="День обращения*"
                    className="input input--md form__date-input js-focus-outside"
                    options={options}
                    onChange={() => {
                      const appealDay = document.getElementById(
                        "property_appeal_day"
                      );
                      setDate(appealDay.value);
                    }}
                  />
                  <div class="form__error active">
                    {errors.property_appeal_day
                      ? errors.property_appeal_day
                          .map((item) => `${item}`)
                          .join("")
                      : ""}
                  </div>
                </div>
                <div
                  className={
                    "select js-select select--md form__item form__item--md" +
                    (errors.property_appeal_time ? " has-error" : "")
                  }
                >
                  <select
                    className="select__item"
                    id="property_appeal_time"
                    name="property_appeal_time"
                    placeholder="Время обращения*"
                  >
                    <option></option>
                    <option>00:00 - 01:00</option>
                    <option>01:00 - 02:00</option>
                    <option>02:00 - 03:00</option>
                    <option>03:00 - 04:00</option>
                    <option>04:00 - 05:00</option>
                    <option>05:00 - 06:00</option>
                    <option>06:00 - 07:00</option>
                    <option>07:00 - 08:00</option>
                    <option>08:00 - 09:00</option>
                    <option>09:00 - 10:00</option>
                    <option>10:00 - 11:00</option>
                    <option>11:00 - 12:00</option>
                    <option>12:00 - 13:00</option>
                    <option>13:00 - 14:00</option>
                    <option>14:00 - 15:00</option>
                    <option>15:00 - 16:00</option>
                    <option>16:00 - 17:00</option>
                    <option>17:00 - 18:00</option>
                    <option>18:00 - 19:00</option>
                    <option>19:00 - 20:00</option>
                    <option>20:00 - 21:00</option>
                    <option>21:00 - 22:00</option>
                    <option>22:00 - 23:00</option>
                    <option>23:00 - 00:00</option>
                  </select>
                  <div class="form__error active">
                    {errors.property_appeal_time
                      ? errors.property_appeal_time
                          .map((item) => `${item}`)
                          .join("")
                      : ""}
                  </div>
                </div>
              </div>
              <div className="form__line">
                <ReactInputMask
                  mask="+7 (999) 999-9999"
                  value={phoneNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPhoneNumber(value);
                  }}
                  name="property_appeal_phone"
                  className="form__item input input--md js-focus-outside"
                  placeholder="Номер телефона, с которого обращались"
                />
              </div>
              <div className="form__line">
                <input
                  name="property_operators_name"
                  className="form__item form__item--md input input--md js-focus-outside"
                  type="text"
                  placeholder="Имя оператора (если помните)"
                />
                <div
                  className={
                    "select js-select select--md form__item form__item--md" +
                    (errors.property_communicated_with ? " has-error" : "")
                  }
                >
                  <select
                    className="select__item"
                    id="property_communicated_with"
                    name="property_communicated_with"
                    placeholder="Вы общались с"
                  >
                    <option></option>
                    <option value="call-center">Оператором колл-центра</option>
                    <option value="technical-service">
                      Технической службой
                    </option>
                  </select>
                  <div class="form__error active">
                    {errors.property_communicated_with
                      ? errors.property_communicated_with
                          .map((item) => `${item}`)
                          .join("")
                      : ""}
                  </div>
                </div>
              </div>
              <div className="form__line">
                <textarea
                  name="property_detail_text"
                  className="textarea textarea--md js-focus-outside"
                  placeholder="Комментарий"
                ></textarea>
              </div>
              <div className="form__condition">
                <div
                  className={
                    "checkbox form__condition-checkbox" + agreement
                      ? ""
                      : " has-error"
                  }
                >
                  <input
                    className="checkbox__input"
                    name="property_personal_data_agreement"
                    id="property_personal_data_agreement"
                    type="checkbox"
                  />
                  <label
                    className="checkbox__label"
                    for="property_personal_data_agreement"
                  >
                    <span
                      className="checkbox__text"
                      style={{ position: "relative", top: "-10px" }}
                    >
                      Даю{" "}
                      <Link
                        className="link"
                        to="https://static.telekarta.tv/policy/ApprovalLkaAbonentsOrionExpress.pdf"
                        target="_blank"
                      >
                        согласие
                      </Link>{" "}
                      на обработку персональных данных
                      <br />в соответствии с{" "}
                      <Link
                        className="link"
                        to="https://static.telekarta.tv/policy/PrivacyPolicyOrion.pdf"
                        target="_blank"
                      >
                        Политикой обработки персональных данных
                      </Link>
                    </span>
                  </label>
                  {!agreement && (
                    <div class="form__error active">Необходимо согласие</div>
                  )}
                </div>
              </div>
            </div>
            <div className="form__form-footer">
              <button
                className="form__submit-btn bttn solid-btn solid-btn--md solid-btn--blue"
                type="submit"
              >
                Отправить форму
              </button>
            </div>
          </form>
          <button className="form__close-btn js-close-popup-btn" type="button">
            <HandySvg
              className="svg-icon"
              src={iconCross}
              width="12"
              height="12"
            />
          </button>
        </section>
      </div>
    </>
  );
};

export default PopupForm;
